import ModalErrorHandler from "@ext/errorHandlers/client/components/ModalErrorHandler";
import { ModalContent, Modal as UiKitModeal } from "ics-ui-kit/components/modal";
import { type ComponentProps, useState } from "react";

const Modal = (props: ComponentProps<typeof UiKitModeal>) => {
	const [isCloseOnError, setIsCloseOnError] = useState(false);

	const closeModal = () => {
		setIsCloseOnError(true);
	};
	return (
		<UiKitModeal {...props} open={!isCloseOnError && props.open}>
			<ModalErrorHandler onClose={closeModal} wrapper={ModalContent}>
				{props.children}
			</ModalErrorHandler>
		</UiKitModeal>
	);
};

export default Modal;
